export interface DeleteCollectionReserveRequest {
  id: number
  collectionNo: string
  reason: string
  memo: string
  canceler: string
}

export function DeleteCollectionReserveRequestToJSON(
  value: DeleteCollectionReserveRequest
): any {
  return {
    id: value.id !== 0 ? value.id : undefined,
    collection_no: value.collectionNo !== '' ? value.collectionNo : undefined,
    reason: value.reason !== '' ? value.reason : undefined,
    memo: value.memo !== '' ? value.memo : undefined,
    canceler: value.canceler !== '' ? value.canceler : undefined
  }
}
